var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.74479 0.68414C1.4519 0.391247 0.977025 0.391247 0.684132 0.68414C0.391239 0.977033 0.391239 1.4519 0.684132 1.7448L3.68934 4.75L0.684132 7.7552C0.391239 8.0481 0.391239 8.52297 0.684132 8.81586C0.977025 9.10876 1.4519 9.10876 1.74479 8.81586L4.75 5.81066L7.7552 8.81586C8.0481 9.10876 8.52297 9.10876 8.81586 8.81586C9.10876 8.52297 9.10876 8.0481 8.81586 7.7552L5.81066 4.75L8.81586 1.7448C9.10876 1.4519 9.10876 0.977033 8.81586 0.68414C8.52297 0.391247 8.0481 0.391247 7.7552 0.68414L4.75 3.68934L1.74479 0.68414Z",
    fill: "#F36E22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.94b2419b3b619927f0ec65141c5c5961.svg";
export { ForwardRef as ReactComponent };